import { getContentLocale } from '~/Features/Configuration/Utils/languageUtils';

export type FormatArgs = Record<string, string | number>;

export interface TxtProps<T> {
    id: keyof T;
    values?: FormatArgs;
}

/**
 * Apply variables to string with {} placeholders
 * ex. format(`{price} is {amount}`, { price: 'Price', amount: 30 })
 */
const format = (template: string, values: FormatArgs) =>
    template.replace(/{(\w+)}/g, (match, index) =>
        typeof values[index] !== 'undefined' ? values[index].toLocaleString(getContentLocale()) : match
    );

export const FormattedText = (text: string, values?: FormatArgs) => (text && values ? format(text, values) : text);
